import index from './index';
import { Router } from '@/legacy/Router';
import show from './show';

Router.get('order', index);
Router.get('order/:any', show);
